import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../../../axiosSetup';
import { setHasConsent } from '../slices/eBLConsentSlice';

export const fetchEblConsentStatus = createAsyncThunk(
  'eblConsent/fetchStatus',
  async (_, { dispatch }) => {
    try {
      await axiosInstance.get('/api/gsbn/v1/action/request/consent');
      dispatch(setHasConsent(true));
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 204 || status === 404) {
        dispatch(setHasConsent(false));
      } else {
        console.error('Failed to fetch eBL consent status', err);
        throw err;
      }
    }
  }
);

export const submitEblConsent = createAsyncThunk(
  'ebl/submitConsent',
  async (values: any, { rejectWithValue }) => {
    try {
      await axiosInstance.post(
        '/api/gsbn/v1/action/request/consent',
        values
      );
      return true;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || 'Consent failed');
    }
  }
);
